import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=7adf0f55&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=7adf0f55&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf0f55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adf0f55')) {
      api.createRecord('7adf0f55', component.options)
    } else {
      api.reload('7adf0f55', component.options)
    }
    module.hot.accept("./UpgradeModal.vue?vue&type=template&id=7adf0f55&scoped=true", function () {
      api.rerender('7adf0f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UpgradeModal.vue"
export default component.exports